import { Timer } from 'easytimer.js';
import { HttpStatusCode } from "axios";
import { FiRotateCcw } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";

import { HiOutlineTrash } from "react-icons/hi";

// import socket from "@/utils/socket";
import GetQuantity from "./GetQuantity";
import { showToast } from "@/utils/toast";
import { TbMessage2 } from "react-icons/tb";
import ReturnModal from "./Modal/ReturnModal";
import RejectModal from "./Modal/RejectModal";
import Lucide from "@/components/Base/Lucide";
import None from "@/assets/images/default.jpg";
// import { SocketEvent } from "@/enum/socketEvent";
import { translateLanguage } from "@/helper/i18n";
import { getFileName, renderTime } from "@/helper";
import { apiReturnItem } from "@/services/ServiceApi";
import { getCurrencyConfig, getShop } from "@/utils/auth";
import { showToastInvalid } from "./Message/showToastInvalid";
import { productStatus, productType, StatusTracking } from "@/config";
import { convertToBaseAmount, formatPriceByCurrency } from "@/utils/helper";

interface CardOrderProps {
    item: productType;
    index: number
    handleIncrease: (id: string, index: number, disPercent: number, qtyStock: number, qty: number) => void;
    handleDecrease: (id: string, index: number, disPercent: number) => void;
    handleCheck: (_id: string) => void;
    handleRemoveItem: (_id: string, index: number) => void;
    handleNote: (event: React.ChangeEvent<HTMLInputElement>, _id: string) => void;
    fetchOrderByTableId: () => void;
}

export default function CardOrder({ item, index, handleDecrease, handleIncrease, handleCheck, handleRemoveItem, handleNote, fetchOrderByTableId }: CardOrderProps) {
    const shop = getShop();
    const { t } = useTranslation();
    const getCurrency = getCurrencyConfig();

    const timerRef = useRef<Timer | null>(null);

    const tableId = localStorage.getItem("tableId");
    // const tableName = localStorage.getItem("tableName");

    const [isRemove, setIsRemove] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [isReturn, setIsReturn] = useState<boolean>(false);
    const [timeText, setTimeText] = useState<string>("00:00:00");

    const [quantity, setQuantity] = useState<string>(String(item.quantity));

    const checkPrice = item.priceItem ? item.priceItem : item.price;

    const priceAfterDiscount = checkPrice * (1 - item.discountPercent / 100);

    const handleRemove = () => {
        setIsRemove(true);
    }

    const onClose = () => {
        setIsRemove(false);
    }

    const confirmRemove = () => {
        handleRemoveItem(item._id, index);
        onClose();
    }

    // const handleReturn = () => {
    //     if (tableId && shop) {
    //         const dataObj = {
    //             status: productStatus.Return,
    //             data: [{
    //                 detailId: item._id,
    //                 orderId: item.orderId,
    //                 tableId: tableId,
    //                 productName: item.name,
    //                 productNameKH: item.nameKH,
    //                 tableName: tableName,
    //             }]
    //         };

    //         if (dataObj.data.length) {
    //             socket.emit(SocketEvent.CHEF_ACTION_ORDER, dataObj, (response: any) => {
    //                 if (response.success) {
    //                     fetchOrderByTableId();
    //                     setIsReturn(false);
    //                     showToast("success");
    //                 } else {
    //                     if (response.statusCode === 401) {
    //                         setTimeout(() => {
    //                             setIsReturn(false);
    //                             showToastInvalid("Request order unauthorized.");
    //                         }, 1000)
    //                     } else {
    //                         setTimeout(() => {
    //                             setIsReturn(false);
    //                             showToastInvalid("Request order invalid.");
    //                         }, 1000)
    //                     }
    //                 }
    //             });
    //         }
    //     } else {
    //         setIsReturn(false);
    //         setTimeout(() => {
    //             showToastInvalid("Request order invalid.");
    //         }, 300)
    //     }
    // }

    const handleReturn = async () => {
        if (tableId && shop) {
            setLoading(true);
            const dataObj = {
                orderItemId: item._id,
                quantity: Number(quantity),
            }

            if (Number(quantity) === 0) {
                showToastInvalid(t("quantityMustBeBiggerThan0"));
                return
            }

            if (Number(quantity) > item.quantity) {
                showToastInvalid(
                    t("maximumQuantity", { quantity: item.quantity })
                );
                return
            }

            const response = await apiReturnItem(item.orderId, dataObj);

            if (response.data.statusCode === HttpStatusCode.Ok) {
                fetchOrderByTableId();
                setIsReturn(false);
                setQuantity("");
                showToast("success");
                setLoading(false)
            } else {
                if (response.data.statusCode === 401) {
                    setTimeout(() => {
                        setIsReturn(false);
                        showToastInvalid("Request order unauthorized.");
                    }, 1000)
                } else {
                    setTimeout(() => {
                        setIsReturn(false);
                        showToastInvalid("Request order invalid.");
                    }, 1000)
                }
            }
        } else {
            setIsReturn(false);
            setTimeout(() => {
                showToastInvalid("Request order invalid.");
            }, 300)
        }
    }

    const getTrackingTime = (statusTracking: StatusTracking) => {
        return { key: "pending", time: statusTracking?.pending };
    };

    const tracking = getTrackingTime(item.tracking);

    useEffect(() => {
        if (!tracking?.time) return;

        const timer = new Timer();

        const startTime = new Date(tracking.time).getTime();
        const now = Date.now();
        const elapsedSeconds = Math.max(0, Math.floor((now - startTime) / 1000));

        timer.start({
            startValues: { seconds: elapsedSeconds }
        });

        setTimeText(timer.getTimeValues().toString());

        timer.addEventListener('secondsUpdated', () => {
            setTimeText(timer.getTimeValues().toString());
        });

        timerRef.current = timer;

        return () => {
            timer.stop();
        };
    }, [tracking?.time]);


    if (!shop) {
        return null
    }

    return (
        <div className="pt-4">
            <div className="flex flex-col gap-2 px-2">
                <div className="pl-6 flex gap-2 relative">
                    <div className="min-h-[70px] min-w-[70px] max-h-[70px] max-w-[70px] border-2 rounded-md relative">
                        <img
                            src={item.image ? getFileName(item.image) : None}
                            width={70}
                            height={70}
                            className="rounded-md object-fill h-[70px]"
                            alt=""
                            onError={(e) => (e.currentTarget.src = None)}
                        />

                        {item.discountPercent != null && item.discountPercent > 0 && (
                            <div className="absolute bg-danger h-4 top-0 left-0 text-[8px] text-white font-bold px-1 rounded-sm z-10 flex items-center justify-center">
                                -{item.discountPercent}%
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col justify-between gap-2 relative flex-1">
                        <h1 className="text-total text-[#292B2C] line-clamp-1 pr-[5rem] pt-1 pb-0.5">
                            {translateLanguage(item.name, item.nameKH ? item.nameKH : item.name)}
                        </h1>
                        {
                            item.options && item.options.map((items, index) => (
                                <p key={index} className={`text-subtotal text-[#383838] capitalize line-clamp-1 ${item.isWaiter ? "" : ""}`}>
                                    {items.name}:
                                    <span className="pl-2">
                                        {items.values
                                            .filter(value => value.isCheck)
                                            .map(value => value.name)
                                            .join(", ")
                                        }
                                    </span>
                                </p>
                            ))
                        }
                        <div className="">
                            {item.discountPercent ? (
                                <div className="flex items-center gap-2">
                                    <div className="text-[12px] 3xl:text-sm font-bold text-danger flex">
                                        {item.isWaiter ?
                                            formatPriceByCurrency(
                                                convertToBaseAmount(
                                                    priceAfterDiscount,
                                                    getCurrency ? getCurrency.code : "USD",
                                                    // getCurrency?.rateToUSD
                                                ),
                                                getCurrency?.symbol
                                            ) :
                                            formatPriceByCurrency(priceAfterDiscount, getCurrency?.symbol)
                                        }
                                    </div>
                                    <span className="text-[10px] 3xl:text-xs text-gray-400 line-through">
                                        {item.isWaiter ?
                                            formatPriceByCurrency(
                                                convertToBaseAmount(
                                                    checkPrice,
                                                    getCurrency ? getCurrency.code : "USD",
                                                    // getCurrency?.rateToUSD
                                                ),
                                                getCurrency?.symbol
                                            ) :
                                            formatPriceByCurrency(checkPrice, getCurrency?.symbol)
                                        }
                                    </span>
                                </div>
                            ) : (
                                <div className="text-[12px] 3xl:text-sm font-bold text-danger">
                                    {item.isWaiter ?
                                        formatPriceByCurrency(
                                            convertToBaseAmount(
                                                item.price,
                                                getCurrency ? getCurrency.code : "USD",
                                                // getCurrency?.rateToUSD
                                            ),
                                            getCurrency?.symbol
                                        ) :
                                        formatPriceByCurrency(item.price, getCurrency?.symbol)
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    {item.isWaiter &&
                        <div className="absolute right-0 top-0 z-10">
                            <HiOutlineTrash size={24} className="text-danger cursor-pointer" onClick={handleRemove} />
                        </div>
                    }
                    <div className="absolute top-0 right-0">
                        <p
                            className={`py-1 px-2.5 2xl:py-2 2xl:px-4 rounded-[6px] text-[10px] 2xl:text-[12px] font-semibold
                                ${item.status === productStatus.Pending ? "bg-[#E19D0F]/10 text-[#E19D0F]" : ""}
                                ${item.status === productStatus.Accept ? "bg-[#527FDF]/10 text-[#527FDF]" : ""}
                                ${item.status === productStatus.Reject ? "bg-danger/10 text-danger" : ""}
                                ${item.status === productStatus.Process ? "bg-[#F1EDFF] text-[#6352A2]" : ""}
                                ${item.status === productStatus.Ready ? "bg-[#41AE5E]/10 text-[#41AE5E]" : ""}
                                ${item.status === productStatus.Completed ? "bg-[#64748B]/10 text-[#64748B]" : ""}
                                ${item.status === productStatus.Return ? "bg-orange-500/10 text-orange-500" : ""}
                            `}
                        >
                            {item.status === productStatus.Pending && t('pending')}
                            {item.status === productStatus.Accept && t('accepted')}
                            {item.status === productStatus.Reject && t('rejected')}
                            {item.status === productStatus.Process && t('cooking')}
                            {item.status === productStatus.Ready && t('ready')}
                            {item.status === productStatus.Completed && t('completed')}
                            {item.status === productStatus.Return && t('returned')}
                        </p>
                    </div>
                    {item.status === productStatus.Completed && item.isReturnable && (
                        <div className="absolute right-0 bottom-0">
                            <button
                                className="rounded-lg py-0.5 px-2 bg-orange-500 hover:bg-orange-600 text-white flex items-center justify-center gap-1 text-[12px] font-medium transition"
                                onClick={() => setIsReturn(true)}
                            >
                                <FiRotateCcw size={14} className="stroke-[3]" />
                                {t("return")}
                            </button>
                        </div>
                    )}
                    {
                        item.tracking && item.status !== productStatus.Completed &&
                        <div className={`absolute right-0 bottom-0 ${renderTime(timeText, shop.performanceConfig.maxServiceTime)} `}>
                            <div className="flex gap-1 items-center text-[12px] font-medium">
                                <Lucide icon="AlarmClock" className="w-4 pb-0.5 stroke-[2]" />
                                {timeText}
                            </div>
                        </div>
                    }
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-1">
                        {
                            item.status > 1 ?
                                <input
                                    className='mr-1 cursor-not-allowed w-5 h-5 rounded-[4px] text-primary border-[#C1C1C1]/30 focus:outline-none focus:ring-0'
                                    type="checkbox"
                                    id={`check-${item._id}`}
                                    disabled
                                    readOnly
                                /> :
                                <input
                                    className='mr-1 cursor-pointer w-5 h-5 rounded-[4px] text-primary border-[#C1C1C1] focus:outline-none focus:ring-0'
                                    type="checkbox"
                                    id={`check-${item._id}`}
                                    checked={item.isCheck || false}
                                    onChange={() => handleCheck(item._id)}
                                />
                        }
                        <p className="w-full border-t-[1px] border-dashed border-[#EAEAEA]"></p>
                    </div>
                    <div className="flex justify-between items-center pl-6">
                        <p className="text-[#202020] text-total py-2">
                            X <span className="text-primary">{item.quantity}</span>
                        </p>
                        {
                            item.status < 2 &&
                            <GetQuantity
                                isWaiter={item.isWaiter}
                                qty={item.quantity}
                                handleDecrease={() => handleDecrease(item._id, index, item.discountPercent)}
                                handleIncrease={() =>
                                    handleIncrease(
                                        item._id,
                                        index,
                                        item.discountPercent,
                                        item.isTrackStock ? (item.inventoryStock?.available ?? 0) : 1,
                                        item.isTrackStock ? item.quantity : 0
                                    )
                                }
                            />
                        }
                    </div>
                </div>
                <div className="flex items-center gap-2 pl-6">
                    <TbMessage2 size={24} className="text-[#767676]" />
                    {
                        item.status < 2 ?
                            <input
                                type="text"
                                value={item.instruction}
                                placeholder="Add notes..."
                                className="w-full text-subtotal text-[#383838] placeholder:text-[#B6B6B6] p-0 focus:ring-0 focus:outline-none border-none"
                                onChange={(e) => handleNote(e, item._id)}
                            /> :
                            <input
                                readOnly
                                disabled
                                type="text"
                                value={item.instruction}
                                placeholder="Add notes..."
                                className="w-full text-subtotal text-[#383838] placeholder:text-[#B6B6B6] p-0 focus:ring-0 focus:outline-none border-none"
                            />
                    }
                </div>
            </div>
            <hr color="#ECE7E7" className="mt-4" />
            <RejectModal
                isOpen={isRemove}
                onRequestClose={onClose}
                onConfirm={confirmRemove}
                message={t('areYouSure')}
                messageH="Are you sure to delete the item ?"
            />
            <ReturnModal
                isOpen={isReturn}
                onRequestClose={() => { setIsReturn(false), setQuantity(String(item.quantity)) }}
                onConfirm={handleReturn}
                message={t('areYouSure')}
                messageH="Are you sure you want to return this item?"
                setQuantity={setQuantity}
                quantity={quantity}
                loading={loading}
            />
        </div>
    )
}
